import { useTranslator } from 'components/shared/hooks';
import React, { FC, Fragment } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import { NotFoundView } from 'views/Errors/NotFound.view';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';

import {
  ROUTE_SCHOOL_OBLIGATION,
  ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS,
  ROUTE_SCHOOL_OBLIGATION_REPORTS,
} from 'config/routes';
import { relativePath } from 'utils/navigation/relativePath';
import { ReportDetailsView } from 'views/Panel/SchoolObligation/ReportDetails/ReportDetails.view';
import { ReportListView } from 'views/Panel/SchoolObligation/ReportList/ReportList.view';

export const SchoolObligationView: FC = () => {
  const trans = useTranslator();

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.SCHOOL_OBLIGATION.OBLIGATION')} static />

      <Routes>
        <Route
          path={relativePath(ROUTE_SCHOOL_OBLIGATION, ROUTE_SCHOOL_OBLIGATION)}
          element={<Navigate to={ROUTE_SCHOOL_OBLIGATION_REPORTS} replace />}
        />
        <Route
          path={relativePath(ROUTE_SCHOOL_OBLIGATION_REPORTS, ROUTE_SCHOOL_OBLIGATION)}
          element={<ReportListView />}
        />
        <Route
          path={relativePath(`${ROUTE_SCHOOL_OBLIGATION_REPORT_DETAILS}/*`, ROUTE_SCHOOL_OBLIGATION)}
          element={<ReportDetailsView />}
        />
        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </Fragment>
  );
};
